export const LOGIN_STARTED = 'LOGIN/LOGIN_STARTED'
export const LOGIN_SUCCESS = 'LOGIN/LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN/LOGIN_FAILURE'